import React, { useMemo, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { QueryClientProvider, QueryClient } from 'react-query';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

// Infrastructure
import client from '@general/graphql/client';
import SearchAPIKeyProvider from '@context/SearchAPIKeyProvider';
import { GlobalModalContext } from '@context/globalModalContext';
import useModal from '@hooks/useModal';
import GlobalModal from '@molecules/GlobalModal';
import ErrorHandler from '../../icsc-app/js/components/_molecules/ErrorHandler';

// Components & Providers
import SessionsDetailProvider from './context/SessionsDetailProvider';
import SessionsPage from './components/pages/SessionsPage';

const queryClient = new QueryClient();

const EventSessionsApp = () => {
    const [searchType] = useState({
        value: 'event_sessions',
        label: 'Sessions',
    });

    // Extract eventCode from window or data attributes
    const eventCode = window.eventCode || document.querySelector('[data-react="EventSessions"]')?.dataset?.eventCode;

    const {
        isModalOpen,
        modalChildren,
        modalOuterClass,
        modalInnerClass,
        setIsModalOpen,
        setModalChildren,
        setModalOuterClass,
        setModalInnerClass,
    } = useModal();

    const modalContextValue = useMemo(() => [
        isModalOpen,
        setIsModalOpen,
        setModalChildren,
        setModalOuterClass,
        setModalInnerClass,
    ], [isModalOpen, modalChildren, modalOuterClass, modalInnerClass]);

    return (
        <ErrorHandler>
            <Router>
                <ApolloProvider client={client}>
                    <QueryClientProvider client={queryClient}>
                        <GlobalModalContext.Provider value={modalContextValue}>

                            <GlobalModal>{modalChildren}</GlobalModal>

                            <SearchAPIKeyProvider>
                                <SessionsDetailProvider eventCode={eventCode}>
                                    <div className="event-sessions-standalone">
                                        <Switch>
                                            <Redirect
                                                exact
                                                from="/attend-and-learn/events/details/:eventSlug"
                                                to="/attend-and-learn/events/details/:eventSlug/schedule"
                                            />

                                            <Route
                                                path="/attend-and-learn/events/details/:eventSlug/schedule"
                                                component={SessionsPage}
                                            />
                                        </Switch>
                                    </div>
                                </SessionsDetailProvider>
                            </SearchAPIKeyProvider>

                        </GlobalModalContext.Provider>
                    </QueryClientProvider>
                </ApolloProvider>
            </Router>
        </ErrorHandler>
    );
};

export default EventSessionsApp;
